<template>
  <div class="gla-budget"
       :class="{ collapsed: !isBottomVisible || !isVisible }"
       v-resize="onResizePage">
    <div class="filters">
      <ul class="filters__col list time">
        <li>10:24 AM</li>
        <li>10/22/21</li>
        <li>Accrual Basis</li>
      </ul>
      <div class="filters__col names">
        <ul class="list">
          <li>ABS Corp</li>
          <li>General Ledger (Summary)</li>
        </ul>
      </div>

    </div>
    <div class="inputs">
      <el-select
          class="select"
          size="mini"
          @change="changeFilter"
          v-model="inputs.filter1"
      >
        <el-option
            v-for="item in filter1List"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-select
          class="select"
          size="mini"
          @change="changeFilter"
          v-model="inputs.filter2"
      >
        <el-option
            v-for="item in filter2List"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-select
          class="select"
          size="mini"
          @change="changeFilter"
          v-model="inputs.filter3"
      >
        <el-option
            v-for="item in filter3List"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-select
          class="select"
          size="mini"
          @change="changeFilter"
          v-model="inputs.filter4"
      >
        <el-option
            v-for="item in filter4List"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <el-select
          class="select"
          size="mini"
          @change="changeFilter"
          v-model="inputs.filter5"
      >
        <el-option
            v-for="item in filter5List"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
    </div>
    <div class="grids-wrapper">
      <ag-grid-vue
          v-show="isVisible"
          :class="{ collapsed: !isBottomVisible }"
          class="ag-theme-balham"
          id="myGrid"
          :gridOptions="gridOptions"
          :defaultColDef="defaultColDef"
          :rowData="rowData"
          :treeData="true"
          :icons="icons"
          :animateRows="true"
          :getDataPath="getDataPath"
          :getRowNodeId="getRowNodeId"
          :getRowHeight="getRowHeight"
          :autoGroupColumnDef="autoGroupColumnDef"
          :columnDefs="columnDefs"
          :groupDefaultExpanded="groupDefaultExpanded"
          @grid-ready="onGridReady"
          :context="context"
          :rowSelection="rowSelection"
          @selection-changed="onSelectionChanged"
          @rowClicked="onRowClicked"
          :rowClassRules="rowClassRules"
      />
      <div v-if="!hideSumRow" class="sum-block-content">
        <div class="sum-block-content__left-side side-content">
          <div class="side-content-col">
            <el-button v-if="isVisible" style="width: 190px;" class="name-button" size="mini">
              {{ $t("general_ledger_incomeStatement") }} (Budget)
            </el-button>
            <el-button style="width: 190px; margin-left: 0;"  class="name-button" size="mini">
              {{ $t("general_ledger_balanceSheet") }} (Budget)
            </el-button>
          </div>
          <div class="side-content-col">
            <el-button v-if="isVisible" class="icon-button" size="mini" @click="clickIncomeStatements" style="padding: 0 10px; height: 28px;">
              <img
                  class="image-icon"
                  v-if="isBottomVisible"
                  src="@/assets/img/toolbar/maximize.svg"
                  width="12px"
                  alt=""
              />
              <img
                  class="image-icon"
                  v-else
                  src="@/assets/img/toolbar/minimize.svg"
                  width="12px"
                  alt=""
              />
            </el-button>
            <el-button class="icon-button" size="mini" @click="clickBalanceSheet" style="padding: 0 10px; height: 28px; margin-left: 0;">
              <img
                  class="image-icon"
                  v-if="isBottomVisible"
                  src="@/assets/img/toolbar/maximize.svg"
                  width="12px"
                  alt=""
              />
              <img
                  class="image-icon"
                  v-else
                  src="@/assets/img/toolbar/minimize.svg"
                  width="12px"
                  alt=""
              />
            </el-button>
          </div>
          <div v-if="isVisible" class="side-content-col">
            <el-select
                size="mini"
                style="margin-left: 14px"
                v-model="filter.datesType"
                placeholder="Dates"
            >
              <el-option
                  v-for="item in datesTypes"
                  :key="item"
                  :label="item"
                  :value="item"
                  @click.native="selectIncomeStatementQuarter(item)"
              >
              </el-option>
            </el-select>
          </div>
          <div class="side-content-col">
            <el-date-picker
                v-if="isVisible"
                ref="datepicker"
                popper-class="custom-date-picker"
                size="mini"
                v-model="filter.dates"
                class="datepicker"
                prefix-icon="el-icon-date"
                type="daterange"
                align="center"
                format="d MMM yy"
                :clearable="false"
                value-format="yyyy-MM-dd"
                range-separator="To"
                start-placeholder="Start date"
                end-placeholder="End date"
                @change="setFilter"
                :picker-options="pickerOptions"
            />
            <div class="as-at-datepicker">
              <span class="t-label"> As At </span>
              <el-date-picker
                  size="mini"
                  format="d MMM yy"
                  class="as-at-datepicker-input"
                  v-model="filter.asAtDate"
                  type="datetime"
                  value-format="timestamp"
                  :picker-options="datepickerSetAsOptions"
                  :clearable="false"
                  @change="setAsAtFilter"
              >
              </el-date-picker>
            </div>
          </div>
          <div class="side-content-col">
            <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-monitor" :disabled="!filter.dates || !filter.dates.length" @click.native="openIncomeStatementModal">View</el-dropdown-item>
                <el-dropdown-item icon="el-icon-printer" @click.native="downloadPdf">PDF</el-dropdown-item>
                <el-dropdown-item icon="fas fa-file-excel" @click.native="() => $refs.downloadexcel.$el.click()">XL</el-dropdown-item>
                <el-dropdown-item icon="el-icon-printer" @click.native="downloadPdf">Print</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <!--                <el-dropdown-item icon="el-icon-monitor">View</el-dropdown-item>-->
                <el-dropdown-item icon="el-icon-printer" @click.native="downloadBalanceSheetPdf">PDF</el-dropdown-item>
                <el-dropdown-item icon="fas fa-file-excel" @click.native="() => $refs.downloadexcel2.$el.click()">XL</el-dropdown-item>
                <el-dropdown-item icon="el-icon-printer" @click.native="downloadBalanceSheetPdf">Print</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="sum-block-content__right-side side-content">
          <div class="side-content-col">
            <div class="net-current-earnings">
              <span class="t-label"> Net Current Earnings </span>
              <el-button class="button-price" size="mini">
                {{
                  formatPrice(incomeStatement ? incomeStatement.amount : 0)
                }}
              </el-button>
            </div>
            <div class="net-current-earnings">
              <span class="t-label">Equity </span>
              <el-button class="button-price" size="mini">
                {{ formatPrice(balanceSheet ? balanceSheet.amount : 0) }}
              </el-button>
            </div>
          </div>
<!--          <el-checkbox-group-->
<!--              class="side-content-col checkboxes"-->
<!--              v-model="filters.shownColumns">-->
<!--            <el-checkbox-->
<!--                v-for="(checkbox, index) in showColumnsList"-->
<!--                :key="index"-->
<!--                :label="index"-->
<!--                @change="-->
<!--                          toggleColumns(checkbox.columns, checkbox.toHideColumns, index)-->
<!--                        "-->
<!--            >-->
<!--              {{-->
<!--                checkbox.name(-->
<!--                    filters.shownColumns.some((x) => x === index) ? "Hide" : "Show"-->
<!--                )-->
<!--              }}-->
<!--            </el-checkbox>-->
<!--          </el-checkbox-group>-->
        </div>
      </div>
      <ag-grid-vue
          v-show="isBottomVisible"
          :class="{ collapsed: !isVisible }"
          class="ag-theme-balham"
          id="myGrid2"
          :icons="icons"
          :gridOptions="gridOptions2"
          :defaultColDef="defaultColDef"
          :rowData="rowData2"
          :treeData="true"
          :animateRows="true"
          :getDataPath="getDataPath"
          :getRowNodeId="getRowNodeId"
          :getRowHeight="getRowHeight"
          :autoGroupColumnDef="autoGroupColumnDef"
          :columnDefs="columnDefs"
          :groupDefaultExpanded="groupDefaultExpanded"
          @grid-ready="onGridReady2"
          :context="context"
          :rowSelection="rowSelection"
          @selection-changed="onSelectionChanged"
          @rowClicked="onRowClicked"
          :rowClassRules="rowClassRules"
      />
    </div>
    <general-ledger-income-statement ref="generalLedgerIncomeStatementModal" />
    <downloadexcel
        v-show="false"
        ref="downloadexcel"
        class="btn download-excel-button"
        :fetch="uploadExcel"
        :fields="json_fields"
    >
    </downloadexcel>
    <downloadexcel
        v-show="false"
        ref="downloadexcel2"
        class="btn download-excel-button"
        :fetch="uploadBalanceSheetExcel"
        :fields="json_fields2"
    >
    </downloadexcel>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import axios from "axios";
import resize from "vue-resize-directive";
import { ObserveVisibility } from "vue-observe-visibility";
import GeneralLedgerIncomeStatement from "@/components/settings/settingsGlAccounts2/GeneralLedgerIncomeStatement";
import downloadexcel from "vue-json-excel";
import moment from "moment";
import jsPDF from "jspdf";

export default {
  name: "GLABudget",
  directives: {
    resize,
    "observe-visibility": ObserveVisibility,
  },
  components: {
    AgGridVue,
    GeneralLedgerIncomeStatement,
    downloadexcel
  },
  computed: {
    companyLayout() {
      return this.$store.getters.getCompanyLayout;
    },
    financialYearStartDateFormatted() {
      return this.companyLayout ? moment(this.companyLayout.financialYearStartDate,"DD-MM-YYYY").format("YYYY-MM-DD") : null
    },
    incomeStatement() {
      const statement = this.doc.find(val => val.account === 'NET CURRENT EARNINGS' )
      return statement
          ? statement
          : null;
    },
    balanceSheet() {
      const balance = this.balanceSheetDoc.find(val => val.type === 'TOTAL EQUITY' )
      return balance
          ? balance
          : null;
    },
  },
  data() {
    return {
      gridApi: null,
      doc: [],
      balanceSheetDoc: [],
      trialBalanceDoc: [],
      gridApi2: null,
      isVisible: true,
      isBottomVisible: true,
      rowClassRules: null,
      inputs: {
        filter1: 1,
        filter2: 1,
        filter3: 1,
        filter4: 1,
        filter5: 1,
        filter6: 1,
      },
      filter: {
        datesType: "None",
        datesType2: null,
        datesType3: null,
        dates: [],
        dates2: [],
        dates3: [],
        asAtDate: moment(),
      },
      filter1List: [ { id: 1, name: 'Business Centres' }],
      filter2List: [{ id: 1, name: 'Business Units' }],
      filter3List: [{ id: 1, name: 'Warehouses' }],
      filter4List: [{ id: 1, name: 'Engagements' }],
      filter5List: [{ id: 1, name: 'Projects' }],
      filter6List: [{ id: 1, name: 'Employees' }],
      rowData: [],
      rowData2: [],
      allRowData: [],
      gridOptions: null,
      gridOptions2: null,
      defaultColDef: null,
      icons: {
        groupExpanded:
            '<img src="https://www.ag-grid.com/example-assets/group/contract.png" style="height: 12px; width: 12px;padding-right: 2px"/>',
        groupContracted:
            '<img src="https://www.ag-grid.com/example-assets/group/expand.png" style="height: 12px; width: 12px;padding-right: 2px"/>',
      },
      datesTypes: ["None", "This financial quarter", "Last financial quarter"],
      getDataPath: null,
      getRowNodeId: null,
      getRowHeight: null,
      autoGroupColumnDef: null,
      gridColumnApi: null,
      gridColumnApi2: null,
      columnDefs: null,
      groupDefaultExpanded: -1,
      context: null,
      rowSelection: "multiple",
      hideSumRow: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "This month",
            onClick(picker) {
              const end = moment().endOf("month");
              const start = moment().startOf("month");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = moment().endOf("month").subtract(1, "months");
              const start = moment().startOf("month").subtract(1, "months");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = moment().endOf("month").subtract(1, "months");
              const start = moment().startOf("month").subtract(3, "months");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "This financial quarter",
            onClick(picker) {
              const end = moment().endOf("quarter");
              const start = moment().startOf("quarter");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last financial quarter",
            onClick(picker) {
              const end = moment().subtract(1, 'quarter').endOf('quarter');
              const start = moment().subtract(1, 'quarter').startOf('quarter');
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "This financial year",
            onClick(picker) {
              const end = moment().endOf("year");
              const start = moment().startOf("year");
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last financial year",
            onClick(picker) {
              const end = moment().endOf("year").subtract(1, "year");
              const start = moment().startOf("year").subtract(1, "year");
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      datepickerSetAsOptions: {
        disabledDate: this.disabledDueDate
      },
      json_fields: {
        Type: "type",
        Class: "class",
        Group: "group",
        Account: "account",
        Amount: "amount",
      },
      json_fields2: {
        Type: "type",
        Class: "class",
        Group: "group",
        Account: "account",
        Amount: "amount",
      },
      // filters: {
      //   shownColumns: [],
      // },
      showColumnsList: [
        {
          columns: ["credit", "debit"],
          toHideColumns: ["endingBalance"],
          name: () => "Trial Balance View",
        },
        {
          columns: ["currencycode", "exchangeRate", "foreignBalance"],
          toHideColumns: [],
          name: () => "Foreign Currency",
        },
      ],
    }
  },
  beforeMount() {
    this.gridOptions = {
      suppressCellSelection: true,
    };
    this.gridOptions2 = {
      suppressCellSelection: true,
    };
    this.getDataPath = (data) => {
      return data.filePath;
    };
    this.getRowNodeId = (data) => {
      return data.id;
    };
    this.getRowHeight = (params) => {
      return 30;
    };
    this.autoGroupColumnDef = {
      headerName: this.$i18n.t("settings_accountThink_GLAccounts_accountsList"),
      field: "name",
      suppressMenu: true,
      // width: 110,
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: function (params) {
          return `<span class="account-list-text grid-text">${params.node.data.name}</span>`;
        },
      },
      cellClass: "account-list",
      cellStyle: {
        "border-right-color": "#e2e2e2",
        "padding-left": "10px",
        "align-items": "center",
        display: "flex",
      },
    };
    this.columnDefs = [
      {
        suppressSizeToFit: true,
        headerName: this.$i18n.t("settings_accountThink_GLAccounts_dbCode"),
        field: "code",
        suppressMenu: true,
        width: 90,
        headerClass: "db-code-header",
        cellClass: "db-code",
        cellStyle: function (params) {
          return {
            "align-items":
                "center; display: flex; padding-left: 10px; border-right-color: #e2e2e2;",
          };
        },
      },
      {
        suppressSizeToFit: true,
        headerName: this.$i18n.t("settings_accountThink_GLAccounts_accNo"),
        field: "number",
        cellClass: "acc-no",
        suppressMenu: true,
        width: 70,
        headerClass: "acc-no-header center-header",
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: '12M Total',
        field: "m12",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M1',
        field: "m1",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M2',
        field: "m2",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M3',
        field: "m3",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M4',
        field: "m4",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M5',
        field: "m5",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M6',
        field: "m6",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M7',
        field: "m7",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M8',
        field: "m8",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M9',
        field: "m9",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M10',
        field: "m10",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M11',
        field: "m11",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
      {
        suppressSizeToFit: true,
        headerName: 'M12',
        field: "m12",
        headerClass: "total center-header",
        suppressMenu: true,
        width: 100,
        cellStyle: {
          "border-right-color": "#e2e2e2",
          "align-items": "center",
          display: "flex",
          "justify-content": "center",
        },
      },
    ];
    this.defaultColDef = {
      editable: (node) => {
        if (node.colDef.cellClass === "acc-no") {
          return true;
        }
        if (node.colDef.cellClass === "account-list") {
          return true;
        }
      },
      onCellValueChanged: (node) => {
        if (!node.newValue) {
          console.log("node", node);
          return;
        }
      },
    };
    this.rowSelection = "multiple";
    this.context = { componentParent: this };
    this.rowClassRules = {
      'no-access-row': "(!data.active && data.entityType === 'account')",
    };
  },
  mounted() {
    this.gridColumnApi = this.gridOptions.columnApi;
    this.gridColumnApi2 = this.gridOptions2.columnApi;
    this.gridColumnApi.moveColumn("code", 0);
    this.gridColumnApi.moveColumn("number", 1);
    this.gridColumnApi2.moveColumn("code", 0);
    this.gridColumnApi2.moveColumn("number", 1);
    this.gridApi = this.gridOptions.api;
    this.gridApi2 = this.gridOptions2.api;
    this.gridApi.sizeColumnsToFit();
    this.gridApi2.sizeColumnsToFit();
  },
  methods: {
    loadList(stateStart, stateEnd) {
      // TODO Changed
      let start = "2022-01-01"
      if (stateStart) start = stateStart
      if (!stateStart && this.companyLayout.financialYearStartDate) {
        start = this.financialYearStartDateFormatted
      }
      return new Promise((resolve, reject) => {
        const end = stateEnd ? stateEnd : moment().format("YYYY-MM-DD");
        let loader = this.$loading.show();
        axios.defaults.headers.common["Authorization"] =
            "Bearer " + sessionStorage.getItem("token");
        axios.defaults.headers.common["X-Timezone-Offset"] = (
            new Date().getTimezoneOffset() / 60
        ).toString();
        axios
            .get(
                `/api/v1/accountDoubleTree/get?companyId=${this.$route.query.companyId}&startDate=${start}&endDate=${end}`
            )
            .then((response) => {
              // change Net Current Earnings from response ))
              const netCurrentEarningIndex = response.data.doubleTree[0].findIndex(val => val.name === 'Net Current Earnings')
              this.rowData = response.data.doubleTree[1].map((val) => ({
                ...val,
                ...{
                  endingBalance: val.DRCRCode === 'CR' ? val.credit : val.debit,
                  exchangeRate: null,
                  foreignBalance: null,
                },
              }));
              const secondDoubleTree = [...response.data.doubleTree[0]]
              if (netCurrentEarningIndex) secondDoubleTree[netCurrentEarningIndex].endingBalance = Number(this.incomeStatement.amount)
              this.rowData2 = secondDoubleTree.map((val, index) => ({
                ...val,
                ...{
                  endingBalance: netCurrentEarningIndex === index ? val.endingBalance : val.DRCRCode === 'CR' ? val.credit : val.debit,
                  exchangeRate: null,
                  foreignBalance: null,
                },
              }));
              // change Net Current Earnings from response ))
              this.allRowData = response.data.doubleTree[1].concat(
                  response.data.doubleTree[0]
              );
              // const hideColumns = [
              //   "credit",
              //   "debit",
              //   "currencycode",
              //   "clashflowObj.name",
              //   "exchangeRate",
              //   "foreignBalance",
              // ];
              //
              // if (this.type === 'gla') hideColumns.push("amount")
              //
              // if (this.filters.shownColumns.length) {
              //   this.showColumnsList.forEach((bal, index) => {
              //     this.toggleColumns(bal.columns, bal.toHideColumns, index)
              //   })
              // } else {
              //   this.gridColumnApi.setColumnsVisible(hideColumns, false);
              //   this.gridColumnApi2.setColumnsVisible(hideColumns, false);
              // }
              this.gridApi.sizeColumnsToFit();
              this.gridApi2.sizeColumnsToFit();
              loader.hide();
              resolve(response.data);
            })
            .catch((error) => {
              console.log("An error occurred:", error);
              loader.hide();
            });
        this.gridApi.sizeColumnsToFit();
        this.gridApi2.sizeColumnsToFit();
      });
    },
    downloadDoc(stateStart, stateEnd) {
      const start = stateStart
          ? stateStart
          : this.financialYearStartDateFormatted
              ? this.financialYearStartDateFormatted
              : "2022-01-01";
      const end = stateEnd ? stateEnd : moment().format("YYYY-MM-DD");
      axios.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("token");
      axios.defaults.headers.common["X-Timezone-Offset"] = (
          new Date().getTimezoneOffset() / 60
      ).toString();
      axios
          .get(
              `/api/v1/income-statement/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}&typeReport=null`
          )
          .then((response) => {
            this.doc = response.data.list;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    onResizePage(val) {
      this.gridApi.sizeColumnsToFit();
      this.gridApi2.sizeColumnsToFit();
    },
    changeFilter() {
      console.log('changeFilter')
    },
    onGridReady(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady2(params) {
      params.api.sizeColumnsToFit();
    },
    onSelectionChanged(api) {
      console.log(api);
    },
    onRowClicked(api) {
    },
    clickIncomeStatements() {
      if (this.isBottomVisible) {
        this.isBottomVisible = false;
      } else {
        this.isBottomVisible = true;
      }
    },
    clickBalanceSheet() {
      if (this.isVisible) {
        this.isVisible = false;
      } else {
        this.isVisible = true;
      }
    },
    selectIncomeStatementQuarter(period) {
      let start = null;
      let end = null;
      switch (period) {
        case "This financial quarter":
          end = moment().endOf("quarter").format("YYYY-MM-DD");
          start = moment().startOf("quarter").format("YYYY-MM-DD");
          break;
        case "Last financial quarter":
          end = moment().subtract(1, 'quarter').endOf('quarter');
          start = moment().subtract(1, 'quarter').startOf('quarter');
          break;
      }
      this.$refs.generalLedgerIncomeStatementModal.openModal(
          start,
          end,
          "QUARTERLY"
      );
    },
    openIncomeStatementModal() {
      const [start, end] = this.filter.dates
      this.$refs.generalLedgerIncomeStatementModal.openModal(start, end);
    },
    async downloadPdf() {
      let loader = this.$loading.show();

      const table = this.doc;

      loader.hide();

      let pdfName = `${Math.floor(Date.now() / 1000)}`;
      const doc = new jsPDF("l", "pt", "a4");
      // doc.text(`${this.results.type.toUpperCase()} Autism Screener`, 15, 10)

      const body = [];
      table.forEach((val, index) => {
        const item = [
          val.type,
          val.class,
          val.group,
          val.account,
          val.amount,
          val.sortOrder,
        ];
        body.push(item);
      });

      doc.autoTable({
        bodyStyles: { fontSize: 7 },
        margin: { top: 5, left: 5, right: 5, bottom: 0 },
        head: [["Type", "Class", "Group", "Account", "Amount"]],
        body: body,
      });

      doc.output("dataurlnewwindow");
    },
    async downloadBalanceSheetPdf() {
      let loader = this.$loading.show();

      const table = this.balanceSheetDoc;

      loader.hide();

      let pdfName = `${Math.floor(Date.now() / 1000)}`;
      const doc = new jsPDF("l", "pt", "a4");

      const body = [];
      table.forEach((val, index) => {
        const item = [val.type, val.class, val.group, val.account, val.amount];
        body.push(item);
      });

      doc.autoTable({
        bodyStyles: { fontSize: 7 },
        margin: { top: 5, left: 5, right: 5, bottom: 0 },
        head: [["Type", "Class", "Group", "Account", "Amount"]],
        body: body,
      });

      doc.output("dataurlnewwindow");
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(",", ".");
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    setFilter(val) {
      if (!val) {
        this.filter.dates = [];
      } else {
        const [start, end] = this.filter.dates
        this.loadList(start, end);
        this.downloadDoc(start, end);
        this.downloadBalanceSheetDoc(start, end);
        this.downloadTrialBalanceDoc(start, end);
        this.filter.asAtDate = moment(this.filter.dates[1], 'YYYY-MM-DD').format('x');
      }
    },
    setAsAtFilter(val) {
      this.filter.dates = [this.filter.dates[0], Number(moment(val, '').format('YYYY-MM-DD'))]
      const [start, end] = this.filter.dates
      this.loadList(start, end);
      this.downloadDoc(start, end);
      this.downloadBalanceSheetDoc(start, end);
      this.downloadTrialBalanceDoc(start, end);
    },
    downloadBalanceSheetDoc(stateStart, stateEnd) {
      const start = stateStart
          ? stateStart
          : this.financialYearStartDateFormatted
              ? this.financialYearStartDateFormatted
              : "2022-01-01";
      const end = stateEnd ? stateEnd : moment().format("YYYY-MM-DD");
      axios.defaults.headers.common["Authorization"] =
          "Bearer " + sessionStorage.getItem("token");
      axios.defaults.headers.common["X-Timezone-Offset"] = (
          new Date().getTimezoneOffset() / 60
      ).toString();
      axios
          .get(
              `/api/v1/balance-sheet/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}`
          )
          .then((response) => {
            this.balanceSheetDoc = response.data.list;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    downloadTrialBalanceDoc(stateStart, stateEnd) {
      const start = stateStart
          ? stateStart
          : this.financialYearStartDateFormatted
              ? this.financialYearStartDateFormatted
              : "2022-01-01";
      const end = stateEnd ? stateEnd : moment().format("YYYY-MM-DD");
      axios.defaults.headers.common["Authorization"] = "Bearer " + sessionStorage.getItem("token");
      axios.defaults.headers.common["X-Timezone-Offset"] = (new Date().getTimezoneOffset() / 60).toString();
      axios.get(`/api/v1/trial-balance/list?companyId=${this.$route.query.companyId}&endDate=${end}&startDate=${start}`)
          .then((response) => {
            this.trialBalanceDoc = response.data.list;
          })
          .catch((err) => {
            console.log(err);
          });
    },
    disabledDueDate (time) {
      if (this.filter.dates[0]) {
        let start = time.getTime() < Number(moment(this.filter.dates[0]).format('x'));
        if (start){
          return start
        }
      }
    },
    async uploadExcel() {
      try {
        let loader = this.$loading.show();

        const table = this.doc;

        loader.hide();

        return table;
      } catch (err) {
        console.log(err);
      }
    },
    async uploadBalanceSheetExcel() {
      try {
        let loader = this.$loading.show();

        const table = this.balanceSheetDoc;

        loader.hide();

        return table;
      } catch (err) {
        console.log(err);
      }
    },
    // toggleColumns(showColumns, hideColumns, index) {
    //   const isFind = this.filters.shownColumns.some((x) => x === index);
    //   this.gridColumnApi.setColumnsVisible(showColumns, isFind);
    //   this.gridColumnApi.setColumnsVisible(hideColumns, !isFind);
    //   this.gridApi.sizeColumnsToFit();
    //
    //   this.gridColumnApi2.setColumnsVisible(showColumns, isFind);
    //   this.gridColumnApi2.setColumnsVisible(hideColumns, !isFind);
    //   this.gridApi2.sizeColumnsToFit();
    // },
  }
}
</script>

<style lang="scss" scoped>
.gla-budget {
  .filters {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    &__col {

    }
    .list {
      list-style: none;
      padding-left: 0;
      li {
        margin-bottom: 4px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .time {
    }
    .names {
      display: flex;
      align-items: center;
      justify-content: center;
      .list {
        text-align: center;
      }
    }
  }
  .inputs {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 10px;
  }
  .grids-wrapper {
    margin-top: 10px;
    #myGrid {
      border: 1px solid #e2e2e2;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      height: 300px;
      min-height: 300px;
      &.collapsed {
        height: calc(100vh - 280px);
      }
      /deep/ .ag-root-wrapper {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
      /deep/.center-header {
        .ag-header-cell-label {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      /deep/.set-as-cell {
        span {
          width: 100%;
          .set-as-text {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .dr-text {
              padding: 0 6px;
              //border-right: 1px solid black;
              box-sizing: border-box;
              min-width: 50%;
              display: flex;
              justify-content: center;
            }
            .cr-text {
              //border-left: 1px solid black;
              box-sizing: border-box;
              min-width: 50%;
              padding: 0 6px;
              display: flex;
              justify-content: center;
              color: red;
            }
          }
        }
      }
      /deep/.action-wrapper {
        display: flex;
        .btn {
          background-color: #ecf5ff;
          border-color: #d9ecff;
          display: inline-block;
          height: 32px;
          padding: 0 10px;
          line-height: 30px;
          font-size: 12px;
          color: #409eff;
          border-width: 1px;
          border-style: solid;
          border-radius: 4px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          white-space: nowrap;
          cursor: pointer;
          &.add-btn {
            margin-right: 10px;
          }
          &.edit-btn {
            margin-right: 10px;
          }
        }
      }
      /deep/ .ag-floating-bottom-container {
        width: 100% !important;
        .opening-text,
        .action-wrapper {
          display: none;
        }
      }
    }
    .sum-block-content {
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      .side-content {
        display: flex;
        gap: 10px;
        padding-right: 150px;
        &-col {
          gap: 10px;
          display: flex;
          flex-direction: column;
          .icon-button {
            display: flex;
            align-items: center;
            justify-content: center;
            /deep/span {
              height: 100%;
              display: flex;
            }
          }
          .datepicker {
            width: 270px;
            /deep/ .el-range-separator {
              padding: 0;
            }
            /deep/ .el-range__close-icon {
              display: none;
            }
          }
          .as-at-datepicker {
            display: flex;
            align-self: flex-end;
            justify-content: flex-end;
            align-items: flex-end;
            gap: 10px;
            font-size: 12px;
            color: #606266;
            &-input {
              width: 134px;
              /deep/ .el-input__inner {
                padding-right: 0;
                color: #606266;
              }
            }
          }
          .el-dropdown-link {
            height: 28px;
            font-size: 12px;
            display: flex;
            align-items: flex-end;
            cursor: pointer;
          }
        }
      }
      &__right-side {
        display: flex;
        justify-content: flex-end;
        align-items: flex-end;
        font-size: 12px;
        gap: 30px !important;
        .side-content-col {
          display: flex;
          flex-direction: column;
          gap: 10px;
          .net-current-earnings {
            display: flex;
            gap: 10px;
            justify-content: flex-end;
            align-items: center;
            .button-price {
              min-width: 100px;
            }
          }
          &.checkboxes {
            /deep/ label {
              height: 28px;
              margin-right: 0;
              font-size: 12px;
              display: flex;
              align-items: center;
              .el-checkbox__label {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
    #myGrid2 {
      border: 1px solid #e2e2e2;
      border-top-left-radius: 0;
      border-top-right-radius: 0;
      height: 300px;
      &.collapsed {
        height: calc(100vh - 290px);
      }
      /deep/ .ag-root-wrapper {
        border-top-left-radius: 0;
        border-top-right-radius: 0;
      }
      /deep/ .ag-header {
        display: none;
      }
      /deep/.center-header {
        .ag-header-cell-label {
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      /deep/.set-as-cell {
        span {
          width: 100%;
          .set-as-text {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            .dr-text {
              padding: 0 6px;
              border-right: 1px solid black;
              box-sizing: border-box;
              min-width: 50%;
              display: flex;
              justify-content: center;
            }
            .cr-text {
              border-left: 1px solid black;
              box-sizing: border-box;
              min-width: 50%;
              padding: 0 6px;
              display: flex;
              justify-content: center;
              color: red;
            }
          }
        }
      }
      /deep/.action-wrapper {
        display: flex;
        .btn {
          background-color: #ecf5ff;
          border-color: #d9ecff;
          display: inline-block;
          height: 32px;
          padding: 0 10px;
          line-height: 30px;
          font-size: 12px;
          color: #409eff;
          border-width: 1px;
          border-style: solid;
          border-radius: 4px;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          white-space: nowrap;
          cursor: pointer;
          &.add-btn {
            margin-right: 10px;
          }
          &.edit-btn {
            margin-right: 10px;
          }
        }
      }
      /deep/ .ag-floating-bottom-container {
        width: 100% !important;
      }
    }
  }
}
</style>